import { Controller, useFormContext } from "react-hook-form";

import { FieldLabel } from "ui/forms";
import { ToggleButtonGroup } from "ui/toggle-button-group";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

import { BUTTON_ALIGNMENT_OPTIONS } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/button-alignment/button-alignment.consts";

interface ButtonAlignmentProps {
  name: string;
  label: string;
}

const ButtonAlignment = ({ name, label }: ButtonAlignmentProps) => {
  const { isEditMode, setButton, button } = useThemePreviewContext();
  const { control } = useFormContext();

  const handleAlignmentChange = (value: string, onChange: (value: string) => void) => {
    if (!isEditMode) return;

    onChange(value);

    if (button) {
      setButton((prev) => {
        if (!prev) return prev;

        return {
          ...prev,
          alignment: value,
        };
      });
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className="flex flex-col gap-1.5">
          <FieldLabel name={name}>{label}</FieldLabel>
          <ToggleButtonGroup
            groupName={name}
            options={BUTTON_ALIGNMENT_OPTIONS}
            value={field.value}
            onChange={(value) => handleAlignmentChange(value, field.onChange)}
            sx={{ width: "100%" }}
            size="md"
            disabled={!isEditMode}
          />
        </div>
      )}
    />
  );
};

export default ButtonAlignment;
